export default {
  namespaced: true,
  state() {
    return {
      user: null,
      token: null,
      menu: null,
      base: null,
      company: null,
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, value) {
      state.token = value
    },
    logout(state) {
      state.user = null
    },
    setProduct(state, value) {
      state.menu = value
    },
    setBase(state, value) {
      state.base = value
    },
    setCompany(state, value) {
      state.company = value
    },
  },
  actions: {
    login({ commit }, userData) {
      commit('setUser', userData)
    },
    token({ commit }, token) {
      commit('setToken', token)
    },
    logout({ commit }) {
      commit('logout')
    },
    product({ commit }, value) {
      commit('setProduct', value)
    },
    company({ commit }, value) {
      commit('setCompany', value)
    },
  },
  getters: {
    isLoggedIn(state) {
      return !!state.user
    },
    token(state) {
      return state.token
    },
    user(state) {
      return state.user
    },
    getProduct(state) {
      return state.menu
    },
    isUserB2b(state) {
      return state.user?.IsB2B === 'true'
    },
    getBase(state) {
      return state.base
    },
    getSystem(state) {
      return state.base?.System
    },
    getCompany(state) {
      return state.company
    },
  }
}